import { typedRoutes } from './utils/module-interfaces';

const oldModuleRoot = `/strata`;
const goodModuleRoot = `/strata-library`;

export const ROUTES = typedRoutes({
    STRATA_LIBRARY_REDIRECT: {
        id: 'STRATA_LIBRARY_REDIRECT',
        name: 'STRATA_LIBRARY_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/`,
        redirectTo: `${goodModuleRoot}/`,
        displayInMenu: false,
    },
    OVERVIEW_REDIRECT: {
        id: 'OVERVIEW_REDIRECT',
        name: 'OVERVIEW_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/overview/`,
        redirectTo: `${goodModuleRoot}/overview/`,
        displayInMenu: false,
    },
    SOUND_EFFECTS_COLLECTIONS_COLLECTION_REDIRECT: {
        id: 'SOUND_EFFECTS_COLLECTIONS_COLLECTION_REDIRECT',
        name: 'SOUND_EFFECTS_COLLECTIONS_COLLECTION_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/sound-effects-collections/collection/:libraryId`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections/collection/:libraryId`,
        displayInMenu: false,
    },
    SOUND_EFFECT_COLLECTION_BAD_REDIRECT: {
        id: 'SOUND_EFFECT_COLLECTION_BAD_REDIRECT',
        name: 'SOUND_EFFECT_COLLECTION_BAD_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/sound-effects-collections/collection`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections`,
        displayInMenu: false,
    },
    SOUND_EFFECTS_COLLECTIONS_ID_REDIRECT: {
        id: 'SOUND_EFFECTS_COLLECTIONS_ID_REDIRECT',
        name: 'SOUND_EFFECTS_COLLECTIONS_ID_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/sound-effects-collections/:libraryId`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections/collection/:libraryId`,
        displayInMenu: false,
    },
    SOUND_EFFECTS_COLLECTIONS_REDIRECT: {
        id: 'SOUND_EFFECTS_COLLECTIONS_REDIRECT',
        name: 'SOUND_EFFECTS_COLLECTIONS_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/sound-effects-collections/`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections/`,
        displayInMenu: false,
    },
    COLLECTIONS_ID_REDIRECT: {
        id: 'COLLECTIONS_ID_REDIRECT',
        name: 'COLLECTIONS_ID_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/collections/:libraryId`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections/collection/:libraryId`,
        displayInMenu: false,
    },
    COLLECTIONS_REDIRECT: {
        id: 'COLLECTIONS_REDIRECT',
        name: 'COLLECTIONS_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/collections/`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections`,
        displayInMenu: false,
    },
    COLLECTION_REDIRECT: {
        id: 'COLLECTION_REDIRECT',
        name: 'COLLECTION_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/collection/:libraryId`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections/collection/:libraryId`,
        displayInMenu: false,
    },
    COLLECTION_BAD_REDIRECT: {
        id: 'COLLECTION_BAD_REDIRECT',
        name: 'COLLECTION_BAD_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/collection`,
        redirectTo: `${goodModuleRoot}/collection`,
        displayInMenu: false,
    },
    STORE_COLLECTION_REDIRECT: {
        id: 'COLLECTION_REDIRECT',
        name: 'COLLECTION_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `/store/collection/:libraryId`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections/collection/:libraryId`,
        displayInMenu: false,
    },
    STORE_COLLECTION_WITH_ID_REDIRECT: {
        id: 'COLLECTION_BAD_REDIRECT',
        name: 'COLLECTION_BAD_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `/store/collection`,
        redirectTo: `${goodModuleRoot}/sound-effects-collections/`,
        displayInMenu: false,
    },
    PRICING_TAB_REDIRECT: {
        id: 'PRICING_TAB_REDIRECT',
        name: 'PRICING_TAB_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/pricing/:selectedTab`,
        redirectTo: `${goodModuleRoot}/pricing/:selectedTab`,
        displayInMenu: false,
    },
    PRICING_REDIRECT: {
        id: 'PRICING_REDIRECT',
        name: 'PRICING_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/pricing`,
        redirectTo: `${goodModuleRoot}/pricing`,
        displayInMenu: false,
    },
    LICENSING_REDIRECT: {
        id: 'LICENSING_REDIRECT',
        name: 'LICENSING_REDIRECT',
        i18nId: 'NOT_NEEDED',
        path: `${oldModuleRoot}/licensing/faq/strataLicenses`,
        redirectTo: `${goodModuleRoot}/licensing/faq/strataLicenses`,
        displayInMenu: false,
    },
});

export const DEFAULT_ROUTE = ROUTES.STRATA_LIBRARY_REDIRECT;
